// export const API_URL =
//   "https://master-api.smartremont.kz" || process.env.VUE_APP_API_URL;
// export const API_URL = "http://127.0.0.1:5000";
export const API_URL = process.env.VUE_APP_API_URL || "http://localhost:8000";

/** Коды типа компании для PUT /project_list/project/writeoff_info/upd/ */
export const WRITEOFF_COMPANY_TYPE_CODE_UK = "UK";
export const WRITEOFF_COMPANY_TYPE_CODE_GP = "GP";
export const MYSPACE_API_URL = "https://api-myspace-sbs.smartremont.kz";
export const FILE_URL = process.env.VUE_APP_FILE_URL;
// export const FILE_URL_OFFICE =
//   "https://office.smartremont.kz" || process.env.VUE_APP_FILE_URL_OFFICE;
export const FILE_URL_OFFICE = process.env.VUE_APP_FILE_URL_OFFICE;
export const MAIN_SYSTEM_URL = process.env.VUE_APP_MAIN_SYSTEM_URL;
export const NCA_SIGN_API_URL = process.env.VUE_APP_NCA_SIGN_API_URL;

/** Отображаемое имя АСР для PROJECT_DIRTY / «Внутренняя черновая отделка» (только UI: список, скачивание, модалки). */
export const ASR_DIRTY_DISPLAY_NAME =
  "Акт принятия выполненных отделочных работ";

export const ASR_DEFAULT_DISPLAY_NAME = "Акт скрытых работ";

export const PROJECT_TYPE_CODE_DIRTY = "PROJECT_DIRTY";
export const PROJECT_TYPE_CODE_SCREED = "PROJECT_SCREED";

/** Лимит ручных/повторных АСР по типу проекта (должен совпадать с asr_manual__get_docs_max в БД). */
export const ASR_DOCS_MAX_BY_PROJECT_TYPE = {
  [PROJECT_TYPE_CODE_DIRTY]: 2,
  [PROJECT_TYPE_CODE_SCREED]: 5,
};
export const DEFAULT_ASR_DOCS_MAX = 1;

export function isProjectTypeDirty(projectTypeCode, projectTypeId) {
  if (projectTypeCode === PROJECT_TYPE_CODE_DIRTY) return true;
  if (projectTypeId != null && projectTypeId !== "") {
    return Number(projectTypeId) === 1;
  }
  return false;
}

/** Базовое название АСР в UI по типу проекта. */
export function getAsrDocumentTitle(projectTypeCode, projectTypeId) {
  return isProjectTypeDirty(projectTypeCode, projectTypeId)
    ? ASR_DIRTY_DISPLAY_NAME
    : ASR_DEFAULT_DISPLAY_NAME;
}

/** Заголовок модалки выбора вызова: «Создать акт …». */
export function getAsrCreatePickCallModalTitle(projectTypeCode, projectTypeId) {
  const title = getAsrDocumentTitle(projectTypeCode, projectTypeId);
  return `Создать ${title.charAt(0).toLowerCase()}${title.slice(1)}`;
}

export function getAsrDocsMaxByProjectType(projectTypeCode) {
  if (!projectTypeCode) return DEFAULT_ASR_DOCS_MAX;
  return ASR_DOCS_MAX_BY_PROJECT_TYPE[projectTypeCode] ?? DEFAULT_ASR_DOCS_MAX;
}

export const PAGES_HEADS = {
  remont: "remont",
  loginUrl: "login-url",
};

export const PAGES = {
  main: "/",
  login: "/login",
  forgetPassword: "/forget-password",
  loginKeycloakCallback: "/login/keycloak/callback",
  loginUrl: `/${PAGES_HEADS.loginUrl}/:token`,
  profile: "/profile",
  invalidObjects: "/invalid-objects",
  openSpaceLinks: "/open-space-links",
  projectsOverview: "/projects-overview",
  packageEntry: "/package-entry",
  packageList: "/package-list",
  imageUrl: "/image-url",
  sbsProject: "/sbs-project",
  sbsPartner: "/sbs-partner",
  sbsCompany: "/sbs-company",
  projectsEntry: "/projects-entry",
  projectsEntryBimSmeta: "/projects-entry/bim-smeta",
  projectSmetaHub: "/project-smeta/:project_id",
  projectAgreementCompare: "/project-agreement-compare/:project_id",
  materials: "/materials",
  residentialSettings: "/residential-settings",
  ptoDocuments: "/pto-documents",
  buildingSettings: "/building-settings",
  frameTypes: "/frame-types",
  framesList: "/frames-list",
  shellEstimates: "/shell-estimates",
  bufferParams: "/buffer-params",
  revitBufferParams: "/revit-buffer-params",
  floorParams: "/floor-params",
  contractors: "/contractors",
  providers: "/providers",
  providerNcaKeys: "/provider-nca-keys",
  projectTypeWarranties: "/project-type-warranties",
  bimCategories: "/bim-categories",
  bimCategoryParams: "/bim-categories_new",
  residentDictionary: "/resident-dictionary",
  bimParams: "/bim-params",
  bimSelectedParams: "/bim-selected-params",
  bimProjects: "/bim-projects",
  bimRooms: "/bim-rooms",
  projectPatternStructure: "/project-pattern-structure",
  projectPatternPeriodMatrix: "/project-pattern-period-matrix",
  residentSmetaOverview: "/resident-smeta-overview",
  tierPlan: "/tier-plan",
  tierFact: "/tier-fact",
  tierDaily: "/tier-daily",
  constructives: "/constructives",
  checkLists: "/check-lists",
  workChecks: "/work-checks",
  tierblocks: "/tier-blocks",
  contractorAgreementList: "/contractor-agreement-list",
  tierFactTimelineTier2to6: "/tier-fact-timeline-2-6",
  tierWorkGroup: "/tier-work-group",
  tierReasonReport: "/tier-reason-report",
  tierFactFirst: "/tier-fact-first",
  handbook: "/handbook/:type",
  handbookMobileApps: "/handbook/mobile-apps",
  handbookMaterialLimits: "/handbook/material-limits",
  handbookProjectLimits: "/handbook/project-limits",
  handbookProjectGeodesists: "/handbook/project-geodesists",
  handbookProjectUspSend: "/handbook/project-usp-send",
  handbookWorkSetCheckGroupSchema: "/handbook/work-set-check-group-schema",
  tradingHouse: "/trading-house",
  tierReason: "/tier-reason",
  jobQueueMonitor: "/job-queue-monitor",
  documentQueueMonitor: "/document-queue-monitor",
  supplierRequestsFromRequired: '/supplier-requests-from-required',
  supplierRequests: "/supplier-requests",
  invoiceApprovals: "/invoice-approvals",
  invoiceApprovalConfig: "/invoice-approval-config",
  providerAgreementList: "/provider-agreement-list",
  avrSetting: "/avr-setting",
  financePaymentCreateForMaster: "/finance-payment-create-for-master",
  financePaymentExcludeProjects: "/finance-payment-exclude-projects",
  geodesistCalls: "/geodesist-calls",
  unsignedSign: "/unsigned-sign",
  smetaChangeLog: "/smeta-change-log",
  foremanWorkAcceptance: "/foreman-work-acceptance",
  employeeTasks: "/employee-tasks",
  acceptance: "/acceptance",
  contractsDictionary: "/contracts-dictionary",
  materialsOverspend: "/materials-overspend",
  required: "/required",
  requiredItems: "/required/:id/items",
  requiredTypes: "/required-types",
  requiredSupplier: "/required-supplier",
  requiredItemsSupplier: "/required-supplier/:id/items",
  requiredSupply: "/required-supply",
  workCheckBpmn: "/work-check-bpmn",
  workCheckBpmnInstances: "/work-check-bpmn-active/instances",
  workCheckBpmnInstance: "/work-check-bpmn-active/instances/:id",
  /** Отчёты → Платежи: сверка план-факт (UI) */
  reportsPlanFactPayment: "/reports/plan-fact-payment",
  /** Отчёты → Расчёты с крупными субподрядчиками SBS */
  reportsContractorSbs: "/reports/contractor-sbs",
  /** Отчёты → Ведомость ресурсов */
  reportsResourceStatement: "/reports/resource-statement",
  /** Отчёты → Остаток ТМЦ на ЖЦП */
  reportsResourceRemainder: "/reports/resource-remainder",
  /** Отчёты → Расхождение цен */
  reportsPriceVariance: "/reports/price-variance",
  /** Отчёты → Сверка SBS, факт и бухгалтерия */
  reportsOperFactBkCompare: "/reports/oper-fact-bk-compare",
  /** Закрытие — закрывающие документы (КС-2В, АВР, М19) */
  closingDocuments: "/closing-documents",
};

export const AUTH_TYPE = { keycloak: "keycloak", local: "local" };

export const LOCALSTORAGEFIELDS = {
  accessToken: "accessTokenMaster",
  refreshToken: "refreshTokenMaster",
  authType: "authTypeMaster",
  fingerToken: "fingerTokenMaster",
  menuDrawerOpen: "menuDrawerOpenMaster",
};

export const MODAL_NAMES = {
  CONFIRM: "ConfirmModal",
  TEXT_MODAL: "modal-text",
  GALLERY_MODAL: "modal-gallery",
  AddMaterialRequest: "AddMaterialRequest",
  AddMaterialRequestBulk: "AddMaterialRequestBulk",
  EditMaterialRequestQty: "EditMaterialRequestQty",
  AddMaterial: "AddMaterial",
  AddProviderEntry: "AddProviderEntry",
  UploadProviderNcaKey: "UploadProviderNcaKey",
  GroupEditUnits: "GroupEditUnits",
  ChangeEntranceDocument: "ChangeEntranceDocument",
  ProjectDocumentSigners: "ProjectDocumentSigners",
  checkGroupHistory: "checkGroupHistory",
  addOpenSpaceLink: "addOpenSpaceLink",
  AddPackageEntry: "AddPackageEntry",
  AddProjectEntry: "AddProjectEntry",
  UpdWriteoffInfo: "UpdWriteoffInfo",
  UpdPackageEntry: "UpdPackageEntry",
  AddResidentEntry: "AddResidentEntry",
  UpdProjectExecutor: "UpdProjectExecutor",
  UpdSet: "UpdSet",
  AddMaterialProviderPrice: "AddMaterialProviderPrice",
  ProjectMaterialsSmeta: "ProjectMaterialsSmeta",
  CopyPasteEntranceProperties: "CopyPasteEntranceProperties",
  ProviderRequestsMaterialSelect: "ProviderRequestsMaterialSelect",
  ChangeProjectMaterials: "ChangeProjectMaterials",
  SchemaPointInfo: "SchemaPointInfo",
  AddFloorMap: "AddFloorMap",
  AddProjectFloor: "AddProjectFloor",
  RESIDENTIAL_GROUPING: "ResidentialGrouping",
  FLOOR_SCHEMA_OBJECT_INFO: "FloorSchemaObjectInfo",
  FLOOR_MAP_ERRORS: "FloorMapErrors",
  FRAME_TYPE_PARAMS: "FrameTypeParams",
  FRAME_UPD: "FrameUpd",
  UPD_FRAME_TYPE_PARAM: "UpdFrameTypeParam",
  AddDocumentEntry: "AddDocumentEntry",
  Add_HANDBOOK_CONTRACTOR: "Add_HANDBOOK_CONTRACTOR",
  Add_HANDBOOK_PROVIDER: "Add_HANDBOOK_PROVIDER",
  AddRevitData: "AddRevitData",
  AddConstructive: "AddConstructive",
  AddConstructivePrice: "AddConstructivePrice",
  EditConstructiveSet: "EditConstructiveSet",
  CreateConstructiveGroupSet: "CreateConstructiveGroupSet",
  EditWorkSetGroup: "EditWorkSetGroup",
  AddBlock: "AddBlock",
  AddTierGroupWork: "AddTierGroupWork",
  EditTierPlan: "EditTierPlan",
  SelectSbsProject: "SelectSbsProject",
  EditTierFact: "EditTierFact",
  EditTierFactTimeline: "EditTierFactTimeline",
  EditLaborFact: "EditLaborFact",
  AddParamLink: "AddParamLink",
  RecalcProjectMaterialPrices: "RecalcProjectMaterialPrices",
  AddProjectLimit: "AddProjectLimit",
  AddMaterialCertificate: "AddMaterialCertificate",
  AddLaboratoryAct: "AddLaboratoryAct",
  AddMobileAppVersion: "AddMobileAppVersion",
  ProviderInvoiceInfo: "ProviderInvoiceInfo",
  ProviderRealizationInfo: "ProviderRealizationInfo",
  AddFloorFlatParamValue: "AddFloorFlatParamValue",
  ChangeProjectDate: "ChangeProjectDate",
  AddPresetKit: "AddPresetKit",
  Edit_Project_Type_Warranty: "Edit_Project_Type_Warranty",
  Select_Warranty: "Select_Warranty",
  Edit_Avr_Setting: "Edit_Avr_Setting",
  ManualAvrCalls: "ManualAvrCalls",
  M19Overuse: "M19Overuse",
  AddMaterialLimit: "AddMaterialLimit",
  EditMaterialLimit: "EditMaterialLimit",
  AddProjectMaterialLimit: "AddProjectMaterialLimit",
  EditProjectMaterialLimit: "EditProjectMaterialLimit",
  AddProjectGeodesist: "AddProjectGeodesist",
  AddWorkSetCheckGroupSchema: "AddWorkSetCheckGroupSchema",
  SelectDate: "SelectDate",
  ExecListCreateDocument: "ExecListCreateDocument",
  ExecListCreatePickCall: "ExecListCreatePickCall",
  PreNuCallSteps: "PreNuCallSteps",
  DuplicateProjectPerformers: "DuplicateProjectPerformers",
  SmetaRecalcSuccess: "SmetaRecalcSuccess",
  UploadInvoice: "UploadInvoice",
  MobileAppPromo: "MobileAppPromo",
  AsrHiddenWorksPreCall: "AsrHiddenWorksPreCall",
  AsrCreatePickCall: "AsrCreatePickCall",
  AsrCreateOrReform: "AsrCreateOrReform",
  DuplicateBpmnSchema: "DuplicateBpmnSchema",
  ProrabK2svTaskConfirm: "ProrabK2svTaskConfirm",
  BuhAvrManualScan: "BuhAvrManualScan",
};
